// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"641f1d2d","88":"23a18db8","113":"9ea845de","204":"74b97235","285":"ef04c6bc","291":"7e9f2609","378":"5e0ad972","444":"bf8328f5","453":"936953c4","712":"71718a18","724":"4ab68eb9","750":"8cd2644c","867":"fa8f050b","869":"4da998a6","979":"a31f88f2"}[chunkId] + ".chunk.js";
};